/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AcquisitionBucketCount interface.
 */
export function instanceOfAcquisitionBucketCount(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    return true;
}
export function AcquisitionBucketCountFromJSON(json) {
    return AcquisitionBucketCountFromJSONTyped(json, false);
}
export function AcquisitionBucketCountFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'key': json['key'],
    };
}
export function AcquisitionBucketCountToJSON(json) {
    return AcquisitionBucketCountToJSONTyped(json, false);
}
export function AcquisitionBucketCountToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'key': value['key'],
    };
}
